
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ChangeDetectorRef, ElementRef, ViewChild, Inject, PLATFORM_ID } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';

import { CoreState } from '@app/store/core/states';
import { storySelector, storyBuilderSelector } from '@modules/story/store/selectors';
import { storyBuilderActions } from '@modules/story/store/actions';
import { mediaDOwnloadSeclector } from '@app/store/features/media/selectors';
import { mediaActions, mediaDownloadAction, mediaRecordAction } from '@app/store/features/media/actions';
import { UtilityHelper } from '@framework/utilities';
import { isPlatformBrowser } from '@angular/common';


@Component({
  selector: 'storyflow-menu-request',
  templateUrl: './storyflow-menu-request.component.html',
  styleUrls: ['./storyflow-menu-request.component.scss']
})
export class StoryflowMenuRequestComponent implements OnInit, OnChanges {
  @Input() showHomeButton: boolean = false;
   
  @Input() storyflowMenu: any;
  @Input() menuActive: any;
  @Input() mediaIndex: number;
  @Input() isMediaIncluded:boolean = true;
  @Input() slidemenu:boolean = false;

  @Output() menuItemClick = new EventEmitter<any>();
  @Output() microphoneClick = new EventEmitter<boolean>()
  @Output() openTagView = new EventEmitter<any>();
  @ViewChild('fileInputMob') fileInputMob: ElementRef;

  private selectStoryCreating$: Observable<boolean>;
  private selectStepCompleted$: Observable<number[]>;
  private selectViewMode$: Observable<string>;
  private selectShowHoverFirstStep$: Observable<boolean>;

  private selectViewModeSubscription: Subscription;
  private selectStoryCreatingSubscription: Subscription;
  private selectStepCompletedSubscription: Subscription;
  private selectShowHoverFirstStepSubscription: Subscription;
  private stepVerifyActionSubscriontion: Subscription;
  private mediaSubscription: Subscription;
  public updatedmenu:any[] = [];

  public isCreating: boolean = false;
  public recordColor:any;
  public cameraColor:any;
  public galleryColor:any;
  public getMediaDonwloaded$: Observable<any>;
  public stepsCompleted: number[] = [];
  public viewMode: string = '';
  public showHoverFirstStep: boolean = false;
  public downloaded: boolean = false;
  private downloadedSubcription: Subscription;
  public disableSubmit: boolean = false;
  public isBrowser:boolean;

  constructor(private store$: Store<CoreState>, private detector: ChangeDetectorRef, private actions$: Actions,
    private utility: UtilityHelper,
     @Inject(PLATFORM_ID) platformId: Object,) {
          this.isBrowser = isPlatformBrowser(platformId);
      }

  ngOnInit() {
    this.selectStoryCreating$ = this.store$.select(storySelector.selectCreating);
    this.selectStepCompleted$ = this.store$.select(storyBuilderSelector.selectStepCompleted);
    this.selectViewMode$ = this.store$.select(storyBuilderSelector.selectViewMode);
    this.selectShowHoverFirstStep$ = this.store$.select(storyBuilderSelector.selectShowHoverFirstStep);
    this.getMediaDonwloaded$ = this.store$.select(mediaDOwnloadSeclector.selectDownloading);

    this.subscription();
  }

  ngOnChanges(): void {
    if (this.menuActive) {
      this.store$.dispatch(new storyBuilderActions.UpdateShowHoverFirstStep(false));
    }

    if(this.storyflowMenu.length){
      this.updatedmenu = this.storyflowMenu.filter((item)=> item.id != 16);
    }

  }

  ngOnDestroy(): void {
    this.unSubscription();
  }
  get isMobile() {
   return false;
  }
  private subscription() {
    this.selectStoryCreatingSubscription = this.selectStoryCreating$.subscribe((creating: boolean) => {
      this.isCreating = creating;

      // this.detector.detectChanges();
    });

        this.mediaSubscription = this.actions$.pipe(
      ofType<mediaDownloadAction.CheckDownloaf>(mediaDownloadAction.ActionTypes.CHECK_DOWNLOAD)
    ).subscribe((action: any) => {
        if(action.download){
          this.disableSubmit = true;
        }
        else{
          this.disableSubmit = false;
        }
      

    })
    this.selectStepCompletedSubscription = this.selectStepCompleted$.subscribe((stepsCompleted: number[]) => {
      this.stepsCompleted = stepsCompleted;
      this.correctStep();
    });

    this.selectViewModeSubscription = this.selectViewMode$.subscribe((viewMode: string) => {
      this.viewMode = viewMode;
    });

    this.selectShowHoverFirstStepSubscription = this.selectShowHoverFirstStep$.subscribe((showHoverFirstStep: boolean) => {
      this.showHoverFirstStep = showHoverFirstStep;

      this.detector.detectChanges();
    });

    this.downloadedSubcription = this.getMediaDonwloaded$.subscribe((staus)=>{
      if(staus != undefined){
        this.downloaded = staus
      }

    })

    this.stepVerifyActionSubscriontion = this.actions$.pipe(
      ofType<storyBuilderActions.ValidateStep>(storyBuilderActions.StoryBuilderActionTypes.VALIDATE_STEP)
    ).subscribe((action) => {
      this.validateStep();
    });
  }

  private unSubscription() {
    this.selectStoryCreatingSubscription.unsubscribe();
    this.selectStepCompletedSubscription.unsubscribe();
    this.selectViewModeSubscription.unsubscribe();
    this.selectShowHoverFirstStepSubscription.unsubscribe();
    this.stepVerifyActionSubscriontion.unsubscribe();
    this.downloadedSubcription.unsubscribe();
  }

  private validateStep() {
    this.storyflowMenu.forEach((menu, index) => {
      menu.valid = this.stepsCompleted.indexOf(menu.id) > -1;
    });
  }

  public startProceess(){
     this.microphoneClick.emit(true)
  }

  private correctStep() {
    let validSteps = this.storyflowMenu.filter(menu => this.stepsCompleted.indexOf(menu.id) > -1);
    validSteps.forEach((menu, index) => {
      menu.valid = true;
    });
  }

  public active($event: MouseEvent, stepId: number) {
    this.slidemenu = true
    // if(this.downloaded){
    //   return;
    // }
    this.openTag(stepId);
    if(stepId == 16){
      this.store$.dispatch(new mediaRecordAction.CheckRecord(true))
    }
    else{
      if(!this.disableSubmit){
        setTimeout(()=>{
          this.store$.dispatch(new mediaRecordAction.CheckRecord(false))
        },1000)
      }
      else{
        this.store$.dispatch(new mediaRecordAction.CheckRecord(true))
      }

    }


    // if(!this.downloaded && stepId != 16){
      
    // }
    // else{
    //   return;
    // }
    $event.stopPropagation(); 
    this.store$.dispatch(new storyBuilderActions.GotoStep(stepId));

  }

  public isCompleted(item) {
    if(item && item.id){
      return this.stepsCompleted.indexOf(item.id) > -1;
    }

  }

  home() {
    this.store$.dispatch(new storyBuilderActions.GotoStep(0));
  }

  activeTag($event){
    let firsttagIndex = this.storyflowMenu.filter(item => item.id != 5 && item.id != 16)
    $event.stopPropagation(); 
    this.store$.dispatch(new storyBuilderActions.GotoStep(firsttagIndex[0].id));
  }

  stepHoveredId: number;

  stepHovered(step?: any) {
    if (step) {
      this.stepHoveredId = step.id;
    } else {
      this.stepHoveredId = null;
    }
  }

  UploadData(data){
    if(data.target.files && data.target.files.length && data.target.files[0].type.includes("image")){
      this.getBase64ImageFromImages(data.target.files[0]).then((res: any) => {
        const imageEditedBlob = this.utility.File.b64ToBlob(res.replace(/^data:(image|binary)\/[^;]+;base64,/, ''), 'image/png');
        //this.previewMedia.fullsize = imageEditedB64;
        imageEditedBlob['path'] = 'story-image';

        this.store$.dispatch((new mediaActions.PassMobileInformation(imageEditedBlob,false)))
       
       })
    }
    else{
      this.store$.dispatch((new mediaActions.PassMobileInformation(data.target.files[0],true)))
    }

  }

  openTag(data){
       this.openTagView.emit(data)
  }
  async getBase64ImageFromImages(imageUrl) {
    // var res = await fetch(imageUrl);
    // var blob = await imageUrl.blob();

    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.addEventListener("load", function () {
        resolve(reader.result);
      }, false);

      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(imageUrl);
    })
  }

  triggerFileInput(){
    if(this.isBrowser){
      this.fileInputMob.nativeElement.click();
    }
  
  }
}

